export default __webpack_public_path__ + "static/media/soccermaxx_banner.5f4cd6e7.png";